import { render, staticRenderFns } from "./TreeItemAdmin.vue?vue&type=template&id=d399af2e&scoped=true"
import script from "./TreeItemAdmin.vue?vue&type=script&lang=js"
export * from "./TreeItemAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d399af2e",
  null
  
)

export default component.exports